import React, { useMemo, useState } from 'react'
import { Modal, Button, Checkbox, Row, Col, Typography, Empty } from 'antd'
import { useSchedulerContext } from '../../../../../context/scheduler/scheduler'
const { Title } = Typography

type TProps = {
	refresh: () => void
}

const DisconnectProfileModal = ({ refresh }: TProps) => {
	const { scheduler, actions } = useSchedulerContext()
	const [visible, setVisible] = useState(false)
	const [profileIds, setProfileIds] = useState<string[]>([])

	const showModal = () => {
		setVisible(true)
		actions.fetchCronofyProfiles()
	}

	const calendarOptions = useMemo(
		() =>
			scheduler.profiles
				? scheduler.profiles.reduce((options: any, profile) => {
						const option = { label: profile.profile_name, value: profile.profile_id }
						if (profile.provider_name !== 'cronofy') {
							options[profile.provider_name] = options[profile.provider_name]
								? [...options[profile.provider_name], option]
								: [option]
						}
						return options
				  }, {})
				: {},
		[scheduler.profiles]
	)

	const handleOk = () => {
		actions.revokeCronofyProfiles(profileIds).then(() => {
			refresh()
			setVisible(false)
		})
	}

	const handleCancel = () => {
		setVisible(false)
	}

	const handleOptionsChange = (checkedValues: any[]) => {
		setProfileIds(checkedValues)
	}

	return (
		<>
			<Button type="primary" shape="round" onClick={showModal} loading={scheduler.loading}>
				Disconnect a Calendar
			</Button>
			<Modal
				title="Disconnect calendars"
				visible={visible}
				onOk={handleOk}
				okText="Disconnect"
				confirmLoading={scheduler.loading}
				onCancel={handleCancel}
				okButtonProps={{ disabled: !profileIds.length }}
			>
				<Checkbox.Group style={{ width: '100%' }} value={profileIds} onChange={handleOptionsChange}>
					{!Object.keys(calendarOptions).length && <Empty />}
					{Object.keys(calendarOptions).map((provider: string) => (
						<Row key={provider} gutter={[0, 15]} style={{ marginTop: 15, marginBottom: 15 }}>
							<Col span={24}>
								<Title level={4} style={{ textTransform: 'capitalize' }}>
									{provider}
								</Title>
							</Col>
							{calendarOptions[provider].map((option: { label: string; value: string }) => (
								<Col span={24} key={option.value}>
									<Checkbox value={option.value}>{option.label}</Checkbox>
								</Col>
							))}
						</Row>
					))}
				</Checkbox.Group>
			</Modal>
		</>
	)
}

export default DisconnectProfileModal
